export default function TrainsSearchParamsFactory(
    flightsUtils,
    userService
) {
    'ngInject';

            const PAGINATION_STEP = 20;

            function Params(module) {
                this.module = module;
                this.TicketSearchSegments = [{_isArrivalTime: false}, {_isArrivalTime: false}, {}, {}];
                //pay attention to 'Travelers' -  mistake from backend side
                this.Travelers = {
                    Adult: {value: 1},
                    Infant: {value: 0},
                    Child: {value: 0},
                };
                this.CabinClass = 0;
                this.SegmentFilterData = [];
                this.Filters = {
                    QuantityOfStops: 3,
                };
                this.min = 0;
                this.max = 20;

                if (this.module === 'flights') {
                    this.IncludeNearbyAirports = false;
                    this.DirectFlightsOnly = false;
                    this.CharityFaresOnly = false;
                    this.IncludeEuroStar = true;
                }
            }

            Params.prototype.recreate = function(search, extendedSearch, options, type) {
                let arrivalAirport;
                let departureAirport;
                const keys = {
                    trains: 'All Train Stations',
                    flights: 'All airports',
                };

                options.infants
                    = flightsUtils.makeTravellersOptions('Infant', extendedSearch.Travelers.Adult, true);
                options.children
                    = flightsUtils.makeTravellersOptions('Child', 4 - extendedSearch.Travelers.Adult, true);

                for (let i = 0; i < search.SearchSegments.length; i++) {
                    arrivalAirport = search.SearchSegments[i].IsArrivalPointCity
                        ? keys[this.module]
                        : search.SearchSegments[i].ArrivalPointName;

                    departureAirport = search.SearchSegments[i].IsDeparturePointCity
                        ? keys[this.module]
                        : search.SearchSegments[i].DeparturePointName;

                    this.TicketSearchSegments[i]._arrival = {
                        DisplayString: search.SearchSegments[i].ArrivalCity + ', '
                        + search.SearchSegments[i].ArrivalCountryCode + ' - '
                        + arrivalAirport + ' (' + search.SearchSegments[i].ArrivalPointCode + ')',
                        airport: arrivalAirport,
                        name: search.SearchSegments[i].ArrivalCity
                        + ', ' + search.SearchSegments[i].ArrivalCountryCode,
                        Code: search.SearchSegments[i].ArrivalPointCode,
                        IsCity: search.SearchSegments[i].IsArrivalPointCity,
                    };

                    this.TicketSearchSegments[i]._departure = {
                        DisplayString: search.SearchSegments[i].DepartureCity + ', '
                        + search.SearchSegments[i].DepartureCountryCode + ' - '
                        + departureAirport + ' (' + search.SearchSegments[i].DeparturePointCode + ')',
                        airport: departureAirport,
                        name: search.SearchSegments[i].DepartureCity
                        + ', ' + search.SearchSegments[i].DepartureCountryCode,
                        Code: search.SearchSegments[i].DeparturePointCode,
                        IsCity: search.SearchSegments[i].IsDeparturePointCity,
                    };

                    this.TicketSearchSegments[i]._time
                        = _.findWhere(options.time, {value: search.SearchSegments[i].DepartureDayTime});
                    this.TicketSearchSegments[i]._date
                        = moment(search.SearchSegments[i].DepartureDate, 'YYYY-MM-DD')
                            .format(userService.getRegionalSettings().dateFormat);
                }
                this.CabinClass = _.findWhere(options.cabinClasses, {value: extendedSearch.CabinClass});
                if (this.module === 'flights') {
                    this.IncludeEuroStar = extendedSearch.IncludeEuroStar;
                    this.IncludeNearbyAirports = extendedSearch.IncludeNearbyAirports;
                    this.CharityFaresOnly = extendedSearch.CharityFaresOnly;
                    this.DirectFlightsOnly = extendedSearch.DirectFlightsOnly;
                    this.PreferredAirlinecode = search.PreferredAirlinecode;
                }
                this.Travelers.Adult = _.findWhere(options.adults, {value: '' + extendedSearch.Travelers.Adult});
                this.Travelers.Child = _.findWhere(options.children, {value: '' + extendedSearch.Travelers.Child});
                this.Travelers.Infant = _.findWhere(options.infants, {value: '' + extendedSearch.Travelers.Infant});
                this.flightType = type;
            };

            Params.prototype.getSearchRequestParams = function getSearchRequestParams(arrivalFlags) {
                const request = angular.copy(this);
                request.CabinClass = request.CabinClass.value;
                request.Travelers.Adult = request.Travelers.Adult.value;
                request.Travelers.Infant = request.Travelers.Infant.value;
                request.Travelers.Child = request.Travelers.Child.value;
                request.TotalPassengerCount
                    = +request.Travelers.Adult + +request.Travelers.Child;

                /**
                 * Remove unused segments in oneway and roundtrip
                 * Switch departure and arrival locations for roundtrip
                 */
                switch (this.flightType) {
                    case 'oneway':
                        request.TicketSearchSegments.length = 1;
                        request.TicketSearchSegments[0]._isArrival = arrivalFlags && arrivalFlags.outbound;
                        break;
                    case 'roundtrip':
                        request.TicketSearchSegments.length = 2;
                        request.TicketSearchSegments[1]._departure
                            = angular.copy(request.TicketSearchSegments[0]._arrival);
                        request.TicketSearchSegments[1]._arrival
                            = angular.copy(request.TicketSearchSegments[0]._departure);
                        request.TicketSearchSegments[0]._isArrival = arrivalFlags && arrivalFlags.outbound;
                        request.TicketSearchSegments[1]._isArrival = arrivalFlags && arrivalFlags.inbound;
                        break;
                    case 'multitrip':

                        /**
                         * Remove unused segments in multitrip
                         */
                        if (!request.TicketSearchSegments[3]._departure) {
                            request.TicketSearchSegments.pop();
                        }
                        if (!request.TicketSearchSegments[2]._departure) {
                            request.TicketSearchSegments.pop();
                        }
                        break;
                    default:
                        break;
                }

                /**
                 * Format segment for request
                 */
                _.forEach(
                    request.TicketSearchSegments, function(segment) {
                        segment.DepartureAirportCode = segment._departure.Code;
                        segment.ArrivalAirportCode = segment._arrival.Code;
                        segment.DepartureDate
                            = moment(segment._date, userService.getRegionalSettings().dateFormat).format('YYYY-MM-DD');
                        segment.DepartureDayTime = segment._time.value;
                        segment.IsDepartureCity = segment._departure.IsCity;
                        segment.IsArrivalCity = segment._arrival.IsCity;
                        segment.DayTimeFilterSource = (segment._isArrival) ? 1 : 0;

                        /**
                         * Remove synthetic fields
                         * Remove synthetic fields
                         */
                        delete segment._departure;
                        delete segment._arrival;
                        delete segment._date;
                        delete segment._time;
                        delete segment._required;
                        delete segment._isArrival;
                        delete segment._isArrivalTime;
                    }
                );

                return request;
            };

            Params.prototype.resetPagination = function resetPagination() {
                this.min = 0;
                this.max = 20;
            };

            /**
             * Set new values for the min/max should be returned
             */
            Params.prototype.adjustPaginationParams = function adjustPaginationParams(totalResults) {
                if ((totalResults - this.max) >= PAGINATION_STEP) {
                    this.min = this.max;
                    this.max = this.max + PAGINATION_STEP;
                } else {
                    this.min = this.max;
                    this.max = totalResults;
                }
            };

            return Params;
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/services/trains-search-params.js